import { ThemeColor } from '@swell/apps-sdk';

export default async function fetchColor(colorValue) {
  const value = new ThemeColor(colorValue);

  debugger;

  return value;
}
